<template>
  <el-container class="backSearche">
    <!--  背影搜索  -->
    <el-card class="tree-card" :body-style="treeCard">
      <div class="tree-card-top">
        <el-form
          ref="formRef"
          :model="formRules"
          :rules="rules"
          label-width="120px"
          label-position="left"
        >
          <el-form-item label="人体照片" prop="picture">
            <h-upload
              @upLoadChange="upLoadChange"
              isCode="1"
              :showUpload="true"
              :iconStyle="{ 'font-size': '85px', 'line-height': '91px' }"
            ></h-upload>
          </el-form-item>
          <el-form-item label="相似度≥">
            <el-input-number
              v-model="formRules.threshold"
              placeholder="请输入"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="查询范围" class="btnBackground">
            <!-- <el-select v-model="cxfw" placeholder="请选择" style="width: 100%">
              <el-option label="离线文件" value="1"></el-option>
              <el-option label="设备" value="2"></el-option>
            </el-select> -->
            <el-button
              style="width: 100%; margin-top: 10px"
              @click="searchRange"
              >{{
                currentEquipment.length > 0
                  ? `已选择${currentEquipment.length}台设备`
                  : "全部设备"
              }}</el-button
            >
          </el-form-item>
          <el-form-item label="抓拍时间">
            <el-select
              v-model="zpsj"
              placeholder="请选择"
              style="width: 100%"
              @change="sjChange"
            >
              <el-option
                v-for="item in listDate"
                :key="item"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="zpsj === ''" label="开始时间" prop="beginTime">
            <el-date-picker
              v-model="formRules.beginTime"
              placeholder="请选择开始时间"
              value-format="YYYY-MM-DD HH:mm:ss"
              type="datetime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item v-if="zpsj === ''" label="结束时间11" prop="endTime">
            <el-date-picker
              v-model="formRules.endTime"
              placeholder="请选择结束时间"
              value-format="YYYY-MM-DD HH:mm:ss"
              type="datetime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="性别">
            <h-selectcode
              bx="bx"
              type="sex"
              v-model="formRules.sex"
              placeholder="请选择"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="年龄" prop="ageUpLimit">
            <h-selectcode
              type="ageDurationType"
              bx="bx"
              v-model="age"
              placeholder="请选择"
              @change="selectChange"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="上身颜色">
            <h-selectcode
              bx="bx"
              type="color"
              v-model="formRules.coatColor"
              placeholder="请选择"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="下身颜色">
            <h-selectcode
              bx="bx"
              type="color"
              v-model="formRules.trousersColor"
              placeholder="请选择"
              :clearable="true"
            ></h-selectcode>
          </el-form-item>
          <el-form-item label="其他">
            <el-checkbox
              true-label="1"
              false-label="-1"
              v-model="formRules.wearCap"
              label="帽子"
              name="1"
            ></el-checkbox>
            <el-checkbox
              true-label="1"
              false-label="-1"
              v-model="formRules.carryBag"
              label="背包"
              name="1"
            ></el-checkbox>
          </el-form-item>
        </el-form>
      </div>
      <div class="tree-card-bottom">
        <h-button
          type="primary"
          :disabled="isValidate"
          @click="queryinstalledAxios(formRef)"
          >查询</h-button
        >
      </div>
    </el-card>
    <el-card class="tabs-card">
      <div class="tabs-card-top">
        <h-button
          v-if="activeName == 'dataListrn'"
          :disabled="checkBoxChangeList.length === 0"
          @click="personAddSlot"
          >加入轨迹 人体</h-button
        >
        <h-button
          v-else
          :disabled="checkBoxChangeFaceList.length === 0"
          @click="personAddSlot"
          >加入轨迹 人脸</h-button
        >
        <!-- <h-button>导出</h-button> -->
      </div>
      <div class="tabs-card-qx">
        <span
          ><el-checkbox
            class="hCheckbox"
            label="全选"
            @change="qxChange"
          ></el-checkbox
        ></span>
        <span v-if="activeName == 'dataListrn'"
          >已选择{{ checkBoxChangeList.length }}个</span
        >
        <span v-else>已选择{{ checkBoxChangeFaceList.length }}个</span>
      </div>
      <el-tabs v-model="activeName" class="tabStyle" @tab-click="handleClick">
        <el-tab-pane label="人脸" name="dataListrt">
          <div
            v-if="dataListrt.length !== 0"
            class="h-card"
            v-loading="loading"
          >
            <h-card
              @checkBoxChange="checkBoxChange"
              @imageListUrl="imageListUrl"
              :moreSelect="moreSelect"
              v-for="(item, index) in dataListrt"
              :key="index"
              :itemRow="item"
              :index="-index"
            ></h-card>
          </div>
          <el-empty
            v-loading="loading"
            v-else
            description="暂无数据"
          ></el-empty>
        </el-tab-pane>
        <el-tab-pane label="人体" name="dataListrn">
          <div
            v-if="dataListrn.length !== 0"
            class="h-card"
            v-loading="loading"
          >
            <h-card
              @checkBoxChange="checkBoxChange"
              @imageListUrl="imageListUrl"
              :moreSelect="moreSelect"
              v-for="(item, index) in dataListrn"
              :key="index"
              :itemRow="item"
              :itemRowIndex="-index"
            ></h-card>
          </div>
          <el-empty
            v-loading="loading"
            v-else
            description="暂无数据"
          ></el-empty>
        </el-tab-pane>
      </el-tabs>
      <!-- <el-pagination
        v-model:currentPage="formRules.page"
        v-model:page-size="formRules.limit"
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next,jumper"
        :total="20"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination> -->
    </el-card>
    <transfer-application
      @transferApplicationList="getTransferList"
      :visible="searchRangeVisible"
      v-show="searchRangeVisible"
    ></transfer-application>
  </el-container>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  provide,
  readonly,
  watchEffect,
} from "vue";
import { detaRq, codeToValue } from "@/utils/library/js/util.js";
import moment from "moment";
import { searchface } from "@/api/smartApplication/personSearchApi.js";
import { ElMessage } from "element-plus";
import {
  savePathList,
  featureallV2,
} from "@/api/smartApplication/smartApplicationApi.js";
export default defineComponent({
  name: "backSearche",
  components: {},
  props: {
    dictList: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, context) {
    const hUploadRef = ref(null);
    const validatePic = (rule, value, callback) => {
      if (!state.formRules.image) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const state = reactive({
      cxfw: "2",
      zpsj: 3,
      checkBoxChangeList: [],
      checkBoxChangeFaceList: [],
      activeName: "dataListrn",
      dataListrt: [],
      dataListrn: [],
      loading: false,
      total: 0,
      age: "",
      listDate: [
        { label: "近3天", value: 3 },
        { label: "近7天", value: 7 },
        { label: "近30天", value: 30 },
        { label: "自定义", value: "" },
      ],
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      searchRangeVisible: false,
      currentEquipment: [],
      formRules: {
        ageLowerLimit: "",
        ageUpLimit: "",
        image: "",
        beginTime: "",
        endTime: "",
        sex: "",
        coatColor: "",
        trousersColor: "",
        wearCap: "-1",
        carryBag: "-1",
        threshold: 60,
        topK: 100,
        deviceIds: [],
        limit: 20, // (integer, optional): 每页数量 ,
        page: "1", // (integer, optional): 页数 ,
      },
      moreSelect: [
        { name: "详情", value: "icon-paixu", path: "ryxq" },
        { name: "搜索", value: "icon-paixu", path: "ss" },
        { name: "加入轨迹", value: "icon-paixu", path: "" },
      ],
      rules: {
        picture: [
          {
            required: true,
            message: "请上传人体图片",
            validator: validatePic,
          },
        ],
      },
      isValidate: false,
      parentDict: {},
    });
    const refData = toRefs(state);
    const formRef = toRefs(null);
    watchEffect(() => {
      state.parentDict = props.dictList;
    });
    //获取穿梭框数据
    const getTransferList = (val) => {
      state.searchRangeVisible = false;
      state.formRules.deviceIds = [];
      val.forEach((element) => {
        state.formRules.deviceIds.push(element.otherId);
      });
      state.currentEquipment = val;
    };
    const searchRange = () => {
      state.searchRangeVisible = true;
    };
    // const treeRef = ref(null);
    // // 点击查询按钮
    // const refreshTable = () => {
    //   tableRef.value && tableRef.value.refresh();
    // };
    // // 重置表单
    // const resetForm = formEl => {
    //   if (!formEl) return;
    //   formEl.resetFields();
    // };
    const methods = {
      imageListUrl(val) {
        context.emit("rnImg", val, state.activeName);
        // hUploadRef.value.uploadFilesValue(val);
        // state.formRules.imageDataList = state.formRules.imageDataList.concat(
        //   val
        // );
        // methods.queryinstalledAxios();
      },
      checkBoxChange(val, is) {
        val.is = is;
        if (is) {
          state.activeName == "dataListrn"
            ? state.checkBoxChangeList.push(JSON.parse(JSON.stringify(val)))
            : state.checkBoxChangeFaceList.push(
                JSON.parse(JSON.stringify(val))
              );
        } else {
          state.activeName == "dataListrn"
            ? state.checkBoxChangeList.forEach((item, index) => {
                if (item.faceId === val.faceId) {
                  state.checkBoxChangeList.splice(index, 1);
                }
              })
            : state.checkBoxChangeFaceList.forEach((item, index) => {
                if (item.faceId === val.faceId) {
                  state.checkBoxChangeFaceList.splice(index, 1);
                }
              });
        }
      },
      qxChange(val) {
        if (val) {
          state.checkBoxChangeList = JSON.parse(
            JSON.stringify(state[state.activeName])
          );
          state[state.activeName].forEach((item) => {
            item.is = true;
          });
        } else {
          state.checkBoxChangeList = [];
          state[state.activeName].forEach((item) => {
            item.is = false;
          });
        }
      },
      handleSizeChange(val) {
        state.formRules.limit = val;
        state.formRules.page = 1;
        methods.queryinstalledAxios(formRef.value);
        // refresh();
      },
      handleCurrentChange(val) {
        if (val > 500) {
          state.formRules.page = "500";
          ElMessage.warning("不能大于500哦");
        } else {
          state.formRules.page = val;
        }

        methods.queryinstalledAxios(formRef.value);
        // refresh();
      },
      // 无图
      async queryinstalledAxios(formEl) {
        if (!formEl) return;
        formEl.validate(async (valid) => {
          if (valid) {
            state.loading = true;
            state.isValidate = true;
            const from = {};
            for (const key in state.formRules) {
              if (state.formRules[key]) {
                from[key] = state.formRules[key];
              }
            }
            if (state.formRules.image.length === 0) {
              delete from.image;
              delete from.carryBag;
              delete from.wearCap;
            }
            await searchface(from).then(
              (res) => {
                state.loading = false;
                state.isValidate = false;
                state.total = res.data.totalCount;
                state.dataListrt = res.data.faceList.map((item) => {
                  item.is = false;
                  codeToValue(item, state.parentDict); //code转value
                  return item;
                });
                console.log(state.dataListrt);
                state.dataListrn = res.data.personList.map((item) => {
                  item.is = false;
                  codeToValue(item, state.parentDict); //code转value
                  return item;
                });
                console.log(state.dataListrn);
              },
              () => {
                state.loading = false;
                state.isValidate = false;
              }
            );
          } else {
            return false;
          }
        });
      },
      // 时间选择
      async sjChange(val) {
        state.formRules.endTime = moment(new Date()).format("YYYY-MM-DD 23:59:59");
        state.formRules.beginTime = moment(new Date().getTime() - 3600 * 1000 * val * 24).format("YYYY-MM-DD 00:00:00");
      },
      // 上传后返回的ba64格式图片
      async upLoadChange(val) {
        if (val.length > 0) {
          state.isValidate = true;
          const posSecond = val[0].lastIndexOf(",");
          const secondImage = val[0].substring(posSecond + 1, val[0].length);
          const params = {
            data: secondImage,
            fileName: "picture",
          };
          const res = await featureallV2([params]);
          if (res.list[0].person) {
            state.formRules.image = secondImage;
            state.isValidate = false;
          }

          // state.formRules.image = secondImage;
        } else {
          state.formRules.image = "";
        }
      },
    };
    methods.sjChange(3);
    provide("dataList", readonly(refData[state.activeName]));
    provide("activeNamery", readonly(refData.activeName));
    //添加数据到轨迹列表
    const personAddSlot = async () => {
      let addSlotArr =
        state.activeName == "dataListrn"
          ? state.checkBoxChangeList
          : state.checkBoxChangeFaceList;
      addSlotArr.forEach(async (itemData, index) => {
        let obj = {
          recordId: itemData.recordId,
          sourceId: itemData.deviceId,
          sourceName: itemData.deviceName,
          online: itemData.online ? itemData.online : "1",
          fullUrl: itemData.imageUrl,
          partUrl: itemData.imagePartUrl,
          passTime: itemData.snapTime,
          longitude: itemData.longitude,
          latitude: itemData.latitude,
          similarityDegree: itemData.similarity,
        };
        const res = await savePathList(obj);
        if (index == addSlotArr.length - 1 && res.code == 0) {
          ElMessage.success("添加成功");

          let arr = addSlotArr.map((item) => {
            return item.recordId;
          });

          state.activeName == "dataListrn"
            ? state.dataListrn.forEach((item) => {
                if (arr.includes(item.recordId)) {
                  item.is = false;
                }
              })
            : state.dataListrt.forEach((item) => {
                if (arr.includes(item.recordId)) {
                  item.is = false;
                }
              });
          state.activeName == "dataListrn"
            ? (state.checkBoxChangeList = [])
            : (state.checkBoxChangeFaceList = []);
        }
      });
    };
    return {
      ...refData,
      ...methods,
      formRef,
      searchRange,
      hUploadRef,
      getTransferList,
      personAddSlot,
      // refreshTable,
      // resetForm
    };
  },
});
</script>
<style lang="scss" scoped>
.backSearche {
  height: 100%;
  .tree-card {
    height: 100%;
    width: 300px;
    .tree-card-top {
      width: 100%;
      height: 90%;
      overflow: auto;
      .el-form-item {
        width: 90%;
        flex-direction: column;
        margin-bottom: calc(var(--font-size) + 0px) !important;
      }
      /deep/.el-upload--picture-card {
        width: 91px;
        height: 91px;
      }
    }
    .tree-card-bottom {
      width: 100%;
      @include flex-row-c-c;
    }
  }
  .tabs-card {
    height: 100%;
    flex: 1;
    margin-left: 10px;
    .tabs-card-top {
      height: 40px;
    }
    .tabs-card-qx {
      height: 40px;
      display: flex;
      justify-content: space-between;
    }
    .tabStyle {
      height: calc(100% - 80px) !important;
      .el-tab-pane {
        overflow: auto;
      }
    }
    .h-card {
      padding: 20px;
      display: grid;

      grid-template-columns: repeat(auto-fill, 199px);
      // grid-template-rows: repeat(auto-fill, 250px);
      grid-gap: 11px 1%;
      overflow: auto;
    }
  }
}
</style>
